<template>
  <el-popover
    v-model:visible="visible"
    trigger="click"
    placement="bottom-start"
    :width="300"
    :disabled="disabled"
    :show-arrow="false"
    popper-class="staff-picker-popper"
    @after-enter="list?.focus()"
    @after-leave="list?.reset()"
  >
    <template #reference>
      <slot />
    </template>

    <StaffPickerList
      ref="list"
      :staff="staff"
      :loading="loading"
      :unassignable="unassignable"
      :assignable-to-me="assignableToMe"
      @select="choose"
    />
  </el-popover>
</template>

<script setup lang="ts">
import { ref } from "vue"
import StaffPickerList from "@/modules/patient-conversations/components/StaffPickerList.vue"
import { PatientConversationStaffOption } from "@/modules/patient-conversations/composables/staff-directory"

withDefaults(
  defineProps<{
    staff: ReadonlyArray<PatientConversationStaffOption>
    loading?: boolean
    disabled?: boolean
    /** Offers "Unassign" as the first option. */
    unassignable?: boolean
    /** Offers "Assign to me"; off when everything selected is already the viewer's. */
    assignableToMe?: boolean
  }>(),
  { loading: false, disabled: false, unassignable: false, assignableToMe: true }
)

const emit = defineEmits<{
  /** The chosen assignee's `usr_…` id, or `null` for "Unassign". */
  (e: "select", staffId: string | null): void
}>()

const visible = ref<boolean>(false)
const list = ref<InstanceType<typeof StaffPickerList>>()

function choose(staffId: string | null): void {
  visible.value = false
  emit("select", staffId)
}
</script>
